import { httpRequest } from '@/shared/api/client';
import { fetchList } from '@/shared/api/jsonapi/client';
import type { Denormalized } from '@/shared/api/jsonapi/parser';

/** Risorsa `user-devices` (BE `UserDevice`). Attributi reali camelCase sul wire.
 *  `deviceHash` = fingerprint del device (impostato al login = model.FingerPrint). */
export interface UserDeviceRow extends Denormalized {
  type: 'user-devices';
  id: string;
  userId?: string;
  deviceHash?: string;
  lastAccess?: string;
  platform?: string;
  deviceName?: string;
  pushToken?: string;
}

export async function fetchMyDevices(userId: string): Promise<UserDeviceRow[]> {
  // UserDevice NON è IHasTenant e non è auto-filtrato per utente: filtriamo noi per userId.
  const { data } = await fetchList<UserDeviceRow>(
    'user-devices',
    { filter: userId ? { userId: { eq: userId } } : undefined, page: { size: 100 } },
  );
  return data;
}

/** Disconnette un singolo device (invalida i token) — BE `DisconnectAll` DTO: { userId, deviceHash }. */
export async function disconnectOneDevice(input: { userId: string; deviceHash: string }): Promise<void> {
  await httpRequest('/api/account/disconnectOneDevice', {
    method: 'POST',
    body: { userId: input.userId, deviceHash: input.deviceHash },
    endpointType: 'plain',
  });
}

/** Disconnette tutti i device tranne (opzionalmente) quello corrente. `isMine=true` +
 *  deviceHash del corrente lo esclude dal reset (BE lo rimuove dalla lista da invalidare). */
export async function disconnectAllDevices(input: { userId: string; currentDeviceHash?: string | null }): Promise<void> {
  await httpRequest('/api/account/disconnectAllDevices', {
    method: 'POST',
    body: {
      userId: input.userId,
      isMine: Boolean(input.currentDeviceHash),
      deviceHash: input.currentDeviceHash ?? '',
    },
    endpointType: 'plain',
  });
}
